import { InventoryItem } from "@1games-ru/region-shared/dist/types/inventory/inventory";
import { useCallback, useMemo, useState } from "react";
import { ItemCategory } from "@/domains/inventory/constants/itemCategory";
import { getGroupsFromItems } from "@/domains/inventory/helpers/getGroupsFromItems";

export default function useFilterItems(items: InventoryItem[]) {
  const filterGroups = useMemo(() => {
    return getGroupsFromItems(items);
  }, [items]);

  const [selectedGroups, setSelectedGroups] = useState<ItemCategory[]>([]);

  const onSelectHandler = useCallback(
    (item: ItemCategory) => {
      const checked = selectedGroups.includes(item);
      setSelectedGroups((state) => {
        if (checked) {
          return state.filter((group) => group !== item);
        }
        return [...state, item];
      });
    },
    [selectedGroups],
  );

  const isAllSelected = useMemo(() => {
    if (filterGroups.length === selectedGroups.length) return true;
    if (selectedGroups.length === 0) return true;
    return false;
  }, [selectedGroups, filterGroups]);

  const filteredItems = useMemo(() => {
    if (isAllSelected) return items;

    return items.filter((item) =>
      selectedGroups.includes(item.itemTemplate.category as ItemCategory),
    );
  }, [items, selectedGroups, isAllSelected]);

  return { filteredItems, filterGroups, selectedGroups, onSelectHandler, isAllSelected };
}
